import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
export default function initFrontPage() {
    if (!document.querySelector('[data-template="homepage"]'))
        return;
    const showreel = document.querySelector(".home__showreel");
    if (!showreel)
        return;
    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: showreel,
            scrub: 1,
            start: "-=200px center",
            end: "120% center",
            // markers: true,
        },
    });
    tl.to(showreel, {
        opacity: 1,
        scale: 1,
        ease: "back.out(1.05)",
    }, 0);
    tl.to(showreel, {
        "--icon-scale": 1,
        "--text-scale": 1,
        ease: "power2.in",
    });
    showreel.addEventListener("mouseenter", () => {
        gsap.to(showreel, {
            "--icon-scale": 1.2,
            ease: "back.out(2)",
        });
    });
    showreel.addEventListener("mouseleave", () => {
        gsap.to(showreel, {
            "--icon-scale": 1,
            ease: "back.out(2)",
        });
    });
}
